<template>
    <div class="filters-wrapper elastic" id="filterWrapperForScrolling">
        <div class="order-wrapper">
            <div class="order-title">
                {{ __('frontend_js.category.order-by') }}:
                {{ order && order.value ? order.title : orderOptions[0].title }}
            </div>
        </div>
        <div class="filter-wrapper">
            <div class="filter-title">
                {{ __('frontend_js.category.select-by-parameters') }}
            </div>
        </div>
        <product-filter-order-options :order-options="orderOptions" />
        <ul class="filter-categories">
            <elastic-product-filter
                v-if="showTrademarksFilter"
                :title="__('frontend_js.category.filter.trademark')"
                data-key="trademarks"
            />
            <elastic-product-filter :title="__('frontend_js.category.filter.size')" data-key="sizes" />
            <elastic-product-filter :title="__('frontend_js.category.filter.color')" data-key="colors" />
            <elastic-product-filter :title="__('frontend_js.category.filter.cut')" data-key="cuts" />
            <elastic-product-filter :title="__('frontend_js.category.filter.material')" data-key="materials" />
            <!-- <elastic-product-filter :title="__('frontend_js.category.filter.sticker')" data-key="stickers" /> -->
            <elastic-product-filter :title="__('frontend_js.category.filter.sticker')" data-key="cmsStickers" />
            <elastic-product-filter
                v-if="canFilterBySeason"
                :title="__('frontend_js.category.filter.season')"
                data-key="seasons"
            />
            <elastic-product-filter
                v-if="canUserFilterByOrderGroup"
                :title="__('frontend_js.category.filter.order_group')"
                data-key="orderGroups"
            />
            <elastic-product-filter
                v-if="canUserFilterByGender"
                :title="__('frontend_js.category.filter.gender')"
                data-key="genders"
            />
            <elastic-product-filter
                v-if="canUserFilterByOrderGroup"
                :title="__('frontend_js.category.filter.attribute')"
                data-key="attributes"
            />
        </ul>
        <elastic-product-active-filters />
        <div
            v-if="coloredProducts.last_page != 1 || coloredProducts.last_page_url.split('=')[1] != 1"
            class="pagination-wrapper subcategories-top-pagination"
        >
            <elastic-product-list-pagination :by-model="byModel" :by-model-id="byModelId" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        paginationData: { required: true },
        filterData: { required: true },
        byModel: { required: true },
        byModelId: { required: true },
        canFilterBySeason: { required: true },
        canUserFilterByOrderGroup: { required: true },
        canUserFilterByGender: { required: true },
        showTrademarksFilter: { default: true },
        productFilterCounterLimit: { default: null },
        aggregationsForActiveFilters: {},
    },
    data() {
        return {
            filters: null,
            urlPath: '',
            currentFilterData: this.filterData,
        };
    },
    computed: {
        ...mapGetters('product-filters', ['queryFilters', 'order', 'orderOptions']),
        ...mapGetters('product-list', ['currentPage', 'coloredProducts']),
        ...mapGetters('auth', ['check']),
        filterApiUrl() {
            if (this.byModel === 'category') return `category/${this.byModelId}`;
            // if (this.byModel == 'category' && this.check == true) return `elastic-category-auth/${this.byModelId}`;
            if (this.byModel === 'trademark' && this.check === true) return `trademarks-auth/${this.byModelId}`;
            else if (this.byModel === 'trademark' && this.check === false) return `trademarks/${this.byModelId}`;
        },
        // lastPageFromLastPageUrl() {
        //     if (this.coloredProducts.last_page_url) {
        //         return this.coloredProducts.last_page_url.split('=')[1] ?? 1;
        //     }
        //     return 1;
        // },
    },
    created() {
        this.urlPath = window.location.pathname.split('/')[1];
        const hideCounter =
            this.productFilterCounterLimit &&
            this.coloredProductsForFilter &&
            this.coloredProductsForFilter.length > this.productFilterCounterLimit;

        this.$store.commit('product-filters/SET_HIDE_COUNTER', hideCounter);
        // this.$store.commit('product-filters/SET_COLORED_PRODUCTS', this.coloredProductsForFilter);
        this.$store.commit('product-filters/SET_FILTER_DATA', this.filterData);
        this.$store.commit('product-filters/SET_AGGREGATIONS_DATA_FOR_ACTIVE_FILTERS', this.aggregationsForActiveFilters);
        this.$store.commit('product-filters/SET_ORDER_OPTIONS', [
            {
                title: this.__('frontend_js.category.order-by-type.recommended'),
                value: '',
            },
            {
                title: this.__('frontend_js.category.order-by-type.price-low-high'),
                value: 'price-asc',
            },
            {
                title: this.__('frontend_js.category.order-by-type.price-high-low'),
                value: 'price-desc',
            },
            {
                title: this.__('frontend_js.category.order-by-type.newest-first'),
                value: 'newest-first',
            },
            {
                title: this.__('frontend_js.category.order-by-type.a-z'),
                value: 'a-z',
            },
        ]);

        this.$store.commit('product-filters/SET_FILTERS');
        this.$store.commit('product-filters/SET_ORDER');
        this.$store.commit('product-list/SET_CURRENT_PAGE');
        this.$root.$on('filterChanged', this.filterChanged);

        window.addEventListener('popstate', event => {
            this.$store.commit('product-filters/SET_FILTERS');
            this.$store.commit('product-filters/SET_ORDER');
            this.$store.commit('product-list/SET_CURRENT_PAGE');
            this.fetchFilteredItems();
        });
    },
    methods: {
        async filterChanged() {
            await this.fetchFilteredItems(1);
            let queryString = this.queryFilters ? '/f/' + this.queryFilters : '';
            if (this.order && this.order.value) queryString += `?sort=${this.order.value}`;
            window.history.pushState(null, null, '/' + this.urlPath + queryString);
        },
        async fetchFilteredItems(page) {
            this.$store.commit('product-list/SET_LOADING', true);
            const response = await this.$store.dispatch('product-list/fetchElasticColoredProducts', {
                url: this.filterApiUrl,
                page: page ? page : this.currentPage,
            });
            this.$store.commit('product-filters/SET_AGGREGATIONS_DATA', response.data.counts);
            this.$store.commit(
                'product-filters/SET_AGGREGATIONS_DATA_FOR_ACTIVE_FILTERS',
                response.data.filterData.aggregationsForActiveFilters
            );
            this.$root.$emit('filtered-products-fetched', response);
            this.$store.commit('product-list/SET_LOADING', false);
        },
    },
};
</script>
